import React from 'react';
import {
	Skeleton,
	type SkeletonProps,
	Typography,
	type TypographyProps,
	type TypographyTypeMap,
} from '@mui/material';
import {styled} from '@netx/core-components/Theme';

const SecondaryTitleRoot = styled(Typography)(({theme}) => ({
	color:
		theme.palette.mode === 'light'
			? 'rgba(0, 0, 0, 0.55)'
			: theme.palette.text.secondary,
})) as typeof Typography;

export type SecondaryTitleProps<
	RootComponent extends React.ElementType = TypographyTypeMap['defaultComponent'],
> = TypographyProps<RootComponent> & {
	loading?: boolean;
	sekeleton?: React.ReactNode;
	SkeletonProps?: Partial<SkeletonProps>;
};

const SecondaryTitlePrimitive = <
	RootComponent extends React.ElementType = TypographyTypeMap['defaultComponent'],
>({
	children,
	loading,
	sekeleton,
	variant = 'body2',
	SkeletonProps,
	...props
}: SecondaryTitleProps<RootComponent>) => {
	if (loading)
		return (
			<>
				{sekeleton || (
					<Skeleton
						style={{width: 50, maxWidth: '100%', height: 20}}
						{...SkeletonProps}
					/>
				)}
			</>
		);

	return (
		<SecondaryTitleRoot<RootComponent>
			variant={variant}
			paragraph={false}
			noWrap
			{...props}
		>
			{children}
		</SecondaryTitleRoot>
	);
};

export const SecondaryTitle = React.memo(
	SecondaryTitlePrimitive,
) as typeof Typography;

export default SecondaryTitle;
